// ==============================|| THEME CONFIG  ||============================== //

const config = {
    defaultPath: '/dashboard',
    defaultPathLogin: '/login',
    defaultPathHome: '/',
    defaultPathNotFound: '/notfound',
    fontFamily: `'Kanit', sans-serif`,
    baseUrl: process.env.REACT_APP_KEY_URLAPI,
    baseUrlImg: process.env.REACT_APP_KEY_URLAPI_IMAGE,
    recruitmentApiEndPoint: process.env.REACT_APP_END_POINT_RECRUITMENT_API,
    rcAttachFileEndPoint: process.env.REACT_APP_END_POINT_RECRUITMENT_API_ATTACHFILE,
    wfAttachFileEndPoint: process.env.REACT_APP_END_POINT_WF_API_ATTACHFILE,
    commonApiEndPoint: process.env.REACT_APP_END_POINT_COMMON_API,
    secretKey: process.env.REACT_APP_SECRET_KEY,
    privateKey: process.env.REACT_APP_PRIVATE_KEY,
};

export default config;
export const drawerWidth = 260;

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
